"use client" 

import Link from "next/link";

import { use, useEffect, useState } from "react";


import axios from "axios";
// import { useState } from "react";
// import { useNavigate, Navigate } from "react-router-dom";
// import BooleanSelect from "../Atoms/Select/BooleanSelect";
import SectorSelect from "@/components/Atoms/Select/SectorSelect";
import InputText from "@/components/Atoms/inputText";
import { capitalizeEveryWord, formatPhoneNumber, humanizeString, removeNumbersAndSpecialChars, standardizeHandle } from "@/utils/frontend/stringOps";
import Alert from "@/components/Atoms/Alerts/Alert";
import validateRequiredFields from "@/utils/frontend/validateRequiredFields";
import LocationSelect from "@/components/Atoms/Select/LocationSelect";
import Hint from "@/components/Atoms/Alerts/Hint";
import EULAModal from "@/components/Organisms/Modals/EULAModal";
import { IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons";
import RadioButton_1 from "@/components/Atoms/Buttons/RadioButton_1";
import LocationSelectGeoNames from "@/components/Atoms/Select/LocationSelectGeoNames";

 
export default function RegistrationHomePage(req) {
  // console.log("REQ@PassiveTalentHomePage", req.searchParams)
  const searchParams = use(req.searchParams)
  const params = use(req.params)
  // const lang = params.lang
  let lang = 'en'

  useEffect(() => {
    const applicationModalOpen = Boolean(searchParams.application);
    const applicationSubmitted = Boolean(searchParams.submitted);

}, []);




  let fieldsInit = {
    user_first_name: false,
    user_last_name: false,
    user_email_address: false, 
    user_password: false, 
    user_password_repeat: false, 
    user_phone_number: false, 
    user_eula: false,
    user_sector_industry: false, 
    user_location: false 

  }

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(fieldsInit)
  const [missingFields, setMissingFields] = useState(fieldsInit)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [hint, setHint] = useState(null)
  const [EULAModalOpen, setEULAModalOpen] = useState(false)
  const [selectedUserType, setSelectedUserType] = useState('RECRUITER')
  const [awaitingEmailVerification, setAwaitingEmailVerification] = useState(false)


  const handleChildCallback = callback => {
    console.log('data', data)
    if (callback) {
      console.log("CB", callback)
      // setData({...data, organization_sector_industry: JSON.stringify({value: callback.value, label_en: callback.label_en, label_fr: callback.label_fr})});

      // setFormData({...formData, organization_industries: callback.selectedSectors.map(x=> x.value).join(';')})

      // setData({...data, organization_sector_industry: JSON.stringify(callback.map(x=>{return {value: x.value, label_en: x.label_en, label_fr: x.label_fr}}).join(';;;')) })
      setData({
        ...data,
        user_sector_industry: callback
          .map(x => JSON.stringify({id: x.id, value: x.value, label_en: x.label_en, label_fr: x.label_fr })) // stringify each object
          .join(';;;') // join them with ";;;"
      });
      callback && setMissingFields({...missingFields, user_sector_industry: false})
    }

  }

  
  const postPutData = {
    user_first_name: data?.user_first_name,
    user_last_name: data?.user_last_name,
    user_email_address: data?.user_email_address,
    user_password: data?.user_password,
    user_phone_number: data?.user_phone_number,
    // user_is_super: true,
    // user_is_root: false,
    user_handle: data?.user_handle,
    user_eula: data?.user_accepted_eula,
    user_sector_industry: data?.user_sector_industry,
    user_location: data?.user_location
  }



const handleSubmit = async () => {
  setLoading(true)
  console.log('postputdata', postPutData)


  let tempMissingFields = validateRequiredFields(document.querySelectorAll('input'), missingFields)
  setMissingFields(tempMissingFields)


  // Log missing fields after they've been updated
  console.log("MISSING FIELDS: ", tempMissingFields);

  // If there are any missing fields, do not proceed with form submission
  if (Object.values(tempMissingFields).includes(true)) {
    // Create a string listing the keys of missing fields
    const missingFieldsList = Object.keys(tempMissingFields)
    .filter(key => tempMissingFields[key] === true) // Filter for missing fields
    .join(', '); // Join them into a string
    setError({message: lang==='fr' ? `Champs obligatoires manquants: ${missingFieldsList}` : `Missing Required Fields: ${missingFieldsList}`})
    setLoading(false)
    return false
  }
  else if (data.user_handle.length < 4 || data.user_handle.length > 15) {
    setMissingFields({...missingFields, user_handle: true})
    setError({message: lang === 'fr' ? "L'identifiant ne doit pas contenir moins de 4 ou plus de 15 charactères." : 'The handle cannot contain less than 4 or more than 15 characters.'})
    setLoading(false)
  }
  else if (data.user_password !== data.user_password_repeat) {
      setMissingFields({...missingFields, user_password_repeat: true})
      setError({message: lang === 'fr' ? 'Les mots de passe ne corréspondent pas.' : 'Passwords do not match.'})
      setLoading(false)
  }
  else if (data.user_password_repeat.length < 7) {
    setMissingFields({...missingFields, user_password: true, user_password_repeat})
    setError({message: lang === 'fr' ? "Le mot de passe ne peut pas contenir moins de 7 charactères." : 'The password cannot contain less than 7 characters.'})
    setLoading(false)
  }
  else if (!data.user_email_address.includes('@')) {
    setMissingFields({...missingFields, user_email_address: true})
    setError({message: lang === 'fr' ? "Cette adresse courriel n'est pas valide." : 'This email address is invalid.'})
    setLoading(false)
}
  else {
    // Proceed with form submission if no fields are missing
    const formData = new FormData();
    formData.append("user_type", selectedUserType);
    formData.append("user_first_name", removeNumbersAndSpecialChars(postPutData.user_first_name));
    formData.append("user_last_name", removeNumbersAndSpecialChars(postPutData.user_last_name));
    formData.append("user_email_address", postPutData.user_email_address);
    formData.append("user_password", postPutData.user_password);
    formData.append("user_phone_number", postPutData.user_phone_number);
    // formData.append("user_is_super", postPutData.user_is_super);
    // formData.append("user_is_root", postPutData.user_is_root);
    formData.append("user_eula", postPutData.user_eula);
    formData.append("user_sector_industry", postPutData.user_sector_industry); // already stringified
    formData.append("user_location", JSON.stringify(postPutData.user_location));
    formData.append("user_handle", standardizeHandle(postPutData.user_handle));
    formData.append("lang", lang);
    formData.append("parent_path", 'window.location.href');
    formData.append("parent_component", "USER_ACCOUNT_REGISTRATION");
    console.log('FDATA', formData.get('user_location'))
    console.log('stringiedloc', JSON.stringify(postPutData.user_location))
    try {
      let apiUrl = `/api/auth/signup`;
      let response = await fetch(apiUrl, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      let responseJSON = await response.json();
      console.log("Response: ", responseJSON)
      if (response.status===200){
        setSuccess({ message: lang === 'fr' ? "Votre compte a été créé." : "Your account has been created." });
        // document.cookie = `token=${JSON.stringify(await responseJSON.token)}`;
        console.log(`resJSON`, responseJSON)
        // document.cookie = `user=${JSON.stringify(await responseJSON.user)}; path=/;`;
        // document.cookie = `organization=${JSON.stringify(await responseJSON.organization)}; path=/;`;
        setLoading(false)
        // window.location.href = `/workspace/`
        setAwaitingEmailVerification(true)
      }
      // else if (response.status===422){
      //   setSuccess({ message: lang === 'fr' ? "Votre compte a été créé." : "Your account has been created." });
      //   // document.cookie = `token=${JSON.stringify(await responseJSON.token)}`;
      //   console.log(`resJSON`, responseJSON)
      //   document.cookie = `user=${JSON.stringify(await responseJSON.user)}; path=/;`;
      //   document.cookie = `organization=${JSON.stringify(await responseJSON.organization)}; path=/;`;
      //       window.location.href = `../workspace/`
      // }
      else {
        // duplicate entry of unique value
        if (responseJSON.error) { 
          setError({message: lang === 'fr' ? `Erreur: ${responseJSON.error.fr}` : `Error: ${responseJSON.error.en}`})
          setLoading(false)
        }
        else if (responseJSON.message.original?.errno === 1062) { 
          let errKeys = Object.keys(responseJSON.message.fields)
          let errValues = Object.values(responseJSON.message.fields)
          setError({message: lang === 'fr' ? `Ce ${humanizeString(errKeys.toString())} existe déjà.` : `This ${humanizeString(errKeys.toString())} already exists.`})
          setMissingFields({...missingFields,  [errKeys]: true})
          setLoading(false)
        }
        else {
          setError({message: lang === 'fr' ? `Erreur: ${response.status} - ${responseJSON.error}` : `Error: ${response.status} - ${responseJSON.error}`})
          setLoading(false)
        }
      }
    } catch (error) {
      setError({message: `Error:  ${error}`})
      console.log('error', error);
      setLoading(false)
    }
  }
};

const handleChange = (x) => {
  // console.log(data)

  // if phone number, allow numbers only
  if (x.target.name === 'user_phone_number') {
    setData({...data, [x.target.name]: formatPhoneNumber(x.target.value)});
    x.target.value.length > 1 && setMissingFields({...missingFields, [x.target.name]: false})
  }
  else {
  setData({...data, [x.target.name]: x.target.value});
    x.target.value.length > 1 && setMissingFields({...missingFields, [x.target.name]: false})
  }
}

const handleCheckboxChange = x => { 
  if (x.target.checked) {
    setMissingFields({...missingFields, user_eula: false});
    setData({...data, user_accepted_eula: true})
  }
  else {
    setData({...data, user_accepted_eula: false})
  }
 
}

  if (awaitingEmailVerification === true ){
    return (
           <div className="">
       <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
       <Hint state={{hint:hint, setHint: setHint}} message={hint?.message}/>

       <EULAModal userType={selectedUserType} lang={lang} state={{EULAModalOpen: EULAModalOpen, setEULAModalOpen: setEULAModalOpen}} callback={(cb)=>{cb.user_accepted_eula ? setData({...data, user_accepted_eula: true}) : setData({...data, user_accepted_eula: false})}}/>
      <title>{lang === 'fr' ? 'Créer un compte avec Talnet' : 'Create an Account with Talnet'}</title>
          {/* center vertically + horizontally */}
          <div className="flex flex-col items-center justify-center min-h-screen gap-4"> 


        
        {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}
         
       
      <div>
      <p>Please check your email (we sent you a verification link)<br/>
      Having trouble verifying your email address? Get support at <Link href="mailto:support@talnet.co">support@talnet.co</Link> </p>
      </div>
      <div>
        












      </div>



      
          {/* <button
            type="submit"
            onClick={handleSubmit}
            className="duration-500 ease-in-out w-full text-white bg-teal-400 hover:bg-teal-500 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
          >
            Register
          </button> */}
        
     
        {/* </form> */}


   




          </div>
     </div>
    )
  }
  return (
 <div className="container mx-auto">

Create your space on Talnet
    <div className="grid grid-cols-span-1 xl:grid-cols-3 mt-20 xl:mt-0 min-h-screen gap-24 justify-center items-center">
      <div className="lg:col-span-2">
        {/* <h1 className="font-ubuntu text-7xl text-slate-300">Join Talnet</h1> */}
          <h1 className="text-5xl xl:text-7xl text-slate-300 dark:text-slate-300 font-ubuntu font-black">
            {lang === 'fr' ? <>Créer un compte avec</> : <>Let's get you started!</>}
          </h1>
                      <div className='w-1/3 border-4 border-teal-300 mt-8'></div>
          <div className="mt-10">
          <h2 className="text-xl">A free Talnet account lets you:</h2>
          <ul className="left-0 w-full font-inter space-y-1 dark:text-white">
            <li><span className="text-teal-300 text-xl">+</span> Discover real talent and opportunities</li>
            <li><span className="text-teal-300 text-xl">+</span> Showcase talent to the network or selectively to clients</li>
            <li><span className="text-teal-300 text-xl">+</span> Password protect your candidates</li>
            <li><span className="text-teal-300 text-xl">+</span> Promote jobs publicly or share them one-to-one with candidates</li>

            <li><span className="text-teal-300 text-xl">+</span> Post, comment, upvote, and exchange insights with recruitment and talent professionals in the field</li>
            <li><span className="text-teal-300 text-xl">+</span> Join the conversation publicly, anonymously, or as a company you manage</li>
            <li><span className="text-teal-300 text-xl">+</span> Control how your profile and activity are seen</li>
            <li><span className="text-teal-300 text-xl">+</span> Follow your favorite names in the talent industry</li>
            <li><span className="text-teal-300 text-xl">+</span> Build visibility through community interaction - at your pace</li>
          </ul>
          </div>
{/* <p className="flex items-center gap-2 h-12">
  <span className="flex items-center text-teal-300 text-3xl leading-none h-12">
    +
  </span>
  <span className="flex items-center h-12">
    Discover real talent and opportunities
  </span>
</p> */}
      </div>
      <div className="lg:col-span-1">
     <div className="">
       <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
       <Hint state={{hint:hint, setHint: setHint}} message={hint?.message}/>

       <EULAModal userType={selectedUserType} lang={lang} state={{EULAModalOpen: EULAModalOpen, setEULAModalOpen: setEULAModalOpen}} callback={(cb)=>{cb.user_accepted_eula ? setData({...data, user_accepted_eula: true}) : setData({...data, user_accepted_eula: false})}}/>
      <title>{lang === 'fr' ? 'Créer un compte avec Talnet' : 'Create an Account with Talnet'}</title>
          {/* center vertically + horizontally */}
          <div className="flex items-center justify-center"> 

      <div className="shadow-xl text-left w-full max-w-lg p-4 bg-white  rounded-3xl shadow sm:p-6 md:p-8 dark:bg-slate-900 dark:border-gray-900 space-y-4">
        
        {/* <form className="space-y-6" onSubmit={handleSubmit} method="POST"> */}
          {/* <h5 className="text-2xl text-slate-400 dark:text-slate-300 font-ubuntu font-black">
            {lang === 'fr' ? <>Créer un compte avec</> : <>Join</>} <span className="text-teal-400">Talnet</span>
          </h5> */}
          <form className="space-y-2">
          <RadioButton_1
                          name="jobTypeRadioSwitch"
                          value1="RECRUITER"
                          value2="EMPLOYER"
                          caption1={lang === 'fr' ? "Recruteur" : "Recruiter"}
                          caption2={lang === 'fr' ? "Employeur" : "Employer"}
                          defaultChecked={'RECRUITER'}
                          callback={(x)=>{setSelectedUserType(x.user_type)}}
                          callbackObjectKey={'user_type'}
                        />
          <div className="flex grid lg:grid-cols-2 gap-1 ">

        <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <InputText 
          name='user_first_name'
          required={true}
          darkBGValue={'dark:bg-slate-900'}
          data={{
            type: 'text',
            id: 'user_first_name',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Votre Prénom' : 'Your First Name',
            value: capitalizeEveryWord(data?.user_first_name || '')
            }}
            error={missingFields?.user_first_name ? true : false}
            />

          </div>
          
          <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <InputText 
          required={true}
          name='user_last_name' 
          darkBGValue={'dark:bg-slate-900'}
          data={{
            type: 'text',
            id: 'user_last_name',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Votre Nom de Famille' : 'Your Last Name',
            value: capitalizeEveryWord(data?.user_last_name || ''),
            }}
            error={missingFields?.user_last_name ? true : false}/>
          </div>
          
          </div>
          <div className="flex grid lg:grid-cols-2 gap-1 ">

        <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <InputText
          name='user_email_address'
          darkBGValue={'dark:bg-slate-900'}
          required={true} 
          data={{
                        type: 'text',
                        id: 'user_email_address',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address',
            value: data?.user_email_address || ''
            }}
            error={missingFields?.user_email_address ? true : false}
            />
          </div>

          <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <InputText
            darkBGValue={'dark:bg-slate-900'}
           onFocus={()=>setHint({message: lang === 'fr' ? "L'identifiant peut inclure des lettres (A-Z), des chiffres (0-9) et un tiret (-), et doit contenir entre 4 et 15 charactères." : <>
            The handle must be <strong>your personal handle</strong>, not your company's handle. You'll have the opportunity to set a separate handle for your company later.<br/>
            The handle can include letters (A-Z), numbers (0-9), and hyphens (-). It must be between 4 and 15 characters.
            </>})}
           onBlur={()=>setHint(null)}
          name='user_handle'
          required={true} 
          data={{
                        type: 'text',
                        id: 'user_handle',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Votre Identifiant' : 'Your Handle',
            // value: data?.user_handle ? data.user_handle : data?.user_first_name && data?.user_last_name ?  standardizeHandle(`${data?.user_first_name} ${data?.user_last_name}`) : ''
            value: data?.user_handle || ''
            }}
            error={missingFields?.user_handle ? true : false}
            />
          </div>



</div>
          
          <div className="flex grid lg:grid-cols-2 gap-1 ">
        <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <div>
          <InputText 
          onFocus={()=>setHint({message: lang === 'fr' ? 'Le mot de passe doit contenir plus de 7 caractères.' : 'The password must contain more than 7 characters.'})}
          onBlur={()=>setHint(null)}
          name='user_password'
          required={true}
          darkBGValue={'dark:bg-slate-900'}
          data={{
            id: 'user_password',
            onChange:(x)=>{handleChange(x)},
            label: lang === 'fr' ? 'Votre Mot de Passe' : 'Your Password',
            value: data?.user_password || '',
            type: 'password',
            }}
            error={missingFields?.user_password ? true : false}/>
          </div>
          </div>
          <div className="ml-0 pl-0 lg:col-span-1 w-full ">
          <div>
          <InputText 
          onBlur={()=>setHint(null)}
          name='user_password_repeat'
          required={true}
          darkBGValue={'dark:bg-slate-900'}
          data={{
            id: 'user_password_repeat',
            onChange:(x)=>{handleChange(x); x.target?.value !== data.user_password ? setHint({message: lang === 'fr' ? 'Les mots de passe ne corréspondent pas.' : 'Passwords do not match.'}) : setHint(null)},
            label: lang === 'fr' ? 'Repetez le Mot de Passe' : 'Repeat Password',
            value: data?.user_password_repeat || '',
            type: 'password',
            }}
            error={missingFields?.user_password_repeat ? true : false}
            />
          </div>
          </div>
</div>
          {/* <div>
          <InputText 
  
          required={true}
          name='user_phone_number'
          data={{
            id: 'user_phone_number',
            onChange:(x)=>{handleChange(x) },
            label: lang === 'fr' ? 'Votre Numéro de Téléphone' : 'Your Phone Number',
            darkBGValue: '900',
            value: data?.user_phone_number || '',
            type: 'phone',
            }}
            error={missingFields?.user_phone_number ? true : false}
            />

          </div> */}


          <div>
            <label className="block mx-1 mt-6 text-xs font-medium text-gray-600 dark:text-gray-400 font-inter">
              {lang === 'fr' ? "Sélectionnez le(s) secteur(s) que vous désservez." : "Select the industries you serve."}
            </label>

            <SectorSelect 
              isMulti={true}
              parent={'USER'} 
              missingRequired={missingFields?.user_sector_industry ? true : false} 
              name={'user_sector_industry'} id={'user_sector_industry'} 
              required={true} 
              callback={handleChildCallback} 
              lang={lang}
              onChange={()=>{}}
              />

<label className="block mx-1 mt-6 text-xs font-medium text-gray-600 dark:text-gray-400 font-inter">
              {lang === 'fr' ? "Sélectionnez votre localisation" : "Select your location"}
            </label>


            {/* <LocationSelect filterHasMarketplaceAccess={false} zoomLevel={'COUNTRIES'} missingRequired={missingFields?.user_location ? true : false} name={'user_location'} id={'user_location'} required={true} onChange={(x)=>{console.log(x); setData({...data, user_location: x?.value});  x?.value.length > 1 && setMissingFields({...missingFields, user_location: false})}}/> */}

              <LocationSelectGeoNames
              required={true}
  missingRequired={missingFields['user_location'] === true ? true : false}
  name="user_location"
  id="user_location"
  placeholder="Start typing in the city name..."
  value={
    data.user_location
      ? {
          value: data.user_location.value,
          label: data.user_location.label
        }
      : null
  }
  // value= { newUserData.user_location || null}
  onChange={(selection) => {
    console.log("SELECTION", selection)
    setData({
      ...data,
      user_location: selection
    });
    selection?.value ? setMissingFields({...missingFields, user_location: false }) : setMissingFields({...missingFields, user_location: true })
  }}
/>


          </div>
          </form>

<div>
      <div className="text-center text-sm dark:text-white font-inter">talnet.co/@{`${data?.user_handle ? standardizeHandle(data.user_handle) : data?.user_first_name && data?.user_last_name ? standardizeHandle(data.user_first_name + ' ' + data.user_last_name) : lang === 'fr' ? 'votre-profil' : 'your-profile' }`}</div>
{/* <div className="text-center text-sm dark:text-white font-inter">talnet.co/@{`${data?.organization_handle ? standardizeHandle(data.organization_handle) : lang === 'fr' ? 'votre-entreprise' : 'your-company' }`}</div> */}
</div>


<div className={`${missingFields?.user_eula ? 'border p-2 rounded-md border-red-500' : false} flex items-center text-xs dark:text-gray-400`}>

  <input name="user_eula" id="user_eula" required={true} type="checkbox" checked={data?.user_accepted_eula || false} onChange={(x)=>handleCheckboxChange(x)} className={`mr-2`}/>
  <span className="mr-1">{lang === 'fr' ? "J'ai lu et accepte le " : 'I have read and accept the'}</span>
  <span>
  <Link href="#EULA" className="text-teal-700 hover:underline dark:text-teal-500" onClick={()=>setEULAModalOpen(true)}>
  {lang === 'fr' ? "Contrat de licence et conditions d'utilisation" : " Terms and License Agreement"}
  </Link>
  </span>
  </div>
  <TealButton loading={loading} onClick={handleSubmit} caption={"Register"} textSize={'text-sm'}/>
          {/* <button
            type="submit"
            onClick={handleSubmit}
            className="duration-500 ease-in-out w-full text-white bg-teal-400 hover:bg-teal-500 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
          >
            Register
          </button> */}
        
          <div className="text-sm font-medium text-right text-gray-500 dark:text-gray-300 font-inter">
            {lang === 'fr' ? 'Vous avez déjà un Compte? ' : `Already registered? `}
            <a
               href={`../workspace`}
              className="text-teal-700 hover:underline dark:text-teal-500"
            >
              {lang === 'fr' ? "Connection" : "Sign in"}
            </a>
          </div>
        {/* </form> */}
      </div>

   




          </div>
     </div>
     </div>
    </div>
</div>

  );
}
